import { Save } from '@material-ui/icons';
import { Grid, Button } from '@material-ui/core';
import useCommentDialog from 'components/CommentDialog/useCommentDialog';
import useDialog from 'components/ConfirmDialog/useDialog';
import useOptionConfirmDialog from 'components/Application/InitialApplication/OptionConfirmDialog/useOptionConfirmDialog';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { setGlobalLoading, setGlobal } from 'store/global/reducer';
import useSubscribe from 'hooks/useSubscribe';
import _ from 'lodash';
import {
    APPLICANT,
    APPROVED,
    CCO,
    CLUSTER_ADMIN,
    DISTRIBUTED,
    DRAFT,
    formLookup,
    IRB,
    REQUEST_FOR_RETURN,
    RETURNED,
    REVIEWED,
    SECRETARY,
    SUBMITTED,
    VERIFIED,
    RE_SUBMITTED,
    CONFIRMED,
    FOR_REVIEW,
    RETURN_FROM_IRB,
    REJECT_REQUEST_FOR_RETURN,
    statusDetailType,
    WITHDRAWN,
    TERMINATED,
    statusLookup,
    HO_ADMIN,
    REVIEWER,
    COMPLETED,
    TAB_STUDY,
    TAB_SITE,
    TAB_AMENDMENT,
    TAB_CONSOLIDATION,
    ACKNOWLEDGED,
    DISAPPROVED,
    EXPIRED,
} from 'utility/lookup';
import ReturnCommentDialog from 'components/ReturnCommentDialog';
import {
    GET_DOWNLOAD_GENERATE_DOC,
    RETURN_TO_SITE,
    SAVE_REMOTE_APPLICATION_DETAIL,
    SEND_TO_COORDINATING_INVESTIGATOR,
    SUBMIT_APPLICATION_FORM,
    UPDATE_APPLICATION_FORM_DETAIL_VALID_STATE,
    UPDATE_APPLICATION_STATUS_WITH_DETAIL,
    SUBMIT_CONSOLIDATION_DETAIL,
    SAVE_CONSOLIDATION_DETAIL,
    DOWNLOAD_APPROVAL_LETTER,
    SET_COMMENT,
    UPDATE_ALL_DRAFT_COMMENT,
    CHECK_COMMENTS_STATUS,
} from 'store/key';
import { getStore } from 'store';
import {
    COMPLETE_BEFORE_NOTIFY,
    COMPLETE_BEFORE_SUBMIT,
    CONFIRM_TO_SEND_TO_CI,
    FORM_SUBMIT_TIPS,
    NOTIFY_CI_SUCCESS,
    UPDATE_APPLICATION_DETAIL_SUCCESS,
    SAVE_APPLICATION_DATA,
    CONFIRM_APPLICATION_SUCCESS,
    CONFIRM_REQUEST_TO_RETURN_CONFIRM,
    REJECT_RETURN_OF_REQUEST_TIPS,
    REJECT_SUCCESS,
    CONFIRM_RETURN_TO_CLUSTER_ADMIN,
    GENERAL_TERMINATE_TIPS,
    GENERAL_TERMINATE_SUCCESS,
    GENERAL_FOR_REVIEW,
    GENERAL_RETURN_TIPS,
    GENERAL_RETURN_SUCCESS,
    GENERAL_RETURN_TO_CLUSTER_ADMIN,
    GENERAL_VERIFY_TIPS,
    GENERAL_DISTRIBUTE_TIPS,
    GENERAL_SUBMIT_SUCCESS,
    GENERAL_RE_SUBMIT_SUCCESS,
    TEXT_OVERFLOW,
    SITE_RETURNED_TIPS,
    GENERAL_RE_SUBMIT_TIPS,
    ARRANGE_REVIEW_ARRANGEMENT_CONFIRM,
    SAVE_BEFORE_PRINT,
    CONSOLIDATION_SAVED,
    GENERAL_CONSOLIDATION_SUCCESS,
    APPLICATION_WITHDRAW_SUCCESS,
    APPLICATION_WITHDRAW_TIPS,
    APPLICATION_DISCARD_TIPS,
    APPLICATION_DISCARD_SUCCESS,
    APPLICATION_RETURN_TO_SITE_SUCCESS,
    APPLICATION_VERIFY_SUCCESS,
    APPLICATION_DISTRIBUTE_SUCCESS,
    CONFIRM_REQUEST_FOR_RETURN_SUCCESS,
} from 'utility/frontendMessage';
import { checkCIAmendment, compareEmail, isFormChanged, permissionChecking } from 'utility/general';
import ConfirmModal from 'components/Modal/ConfirmModal';
import { checkFormValid, checkNull, formCheckBeforeSave, returnCondition } from 'utility/formValidate';
import { siteInfoLookup, studyInfoLookup } from 'utility/formLookup';
import api from 'api/call';

export const useApplicationBarAction = ({
    applicationDetail = {},
    siteInfoId = -1,
    tabType,
    statusId,
    isAmendment,
    currentTabKey,
    documentType,
}) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const showDialog = useDialog();
    const showCommentDialog = useCommentDialog();
    const showOptionCommentDialog = useOptionConfirmDialog();
    const [isConfirmDialogShow, setConfirmDialogShow] = useState(false);
    const [isCCOReturnDialog, setCCOReturnDialog] = useState(false);

    const user = useSelector((state) => state.user);
    const userRole = useSelector((state) => state.user.role);
    const { commentsStatusResubmit, commentsStatusToIRB } = useSelector((state) => state.comment);
    const userDetail = user?.detail;
    const applicationId = applicationDetail?.applicationForm?.id ?? -1;
    const formId = applicationDetail?.applicationForm?.id ?? -1;

    const { allConfig } = useSelector((state) => state.system);
    const commentConfig = allConfig?.list?.find(item => item?.code === 'comment');
    const currentWorkFlow = applicationDetail?.applicationForm?.workflow; 
    const codeValueArr = commentConfig?.codeValue?.split(";");  // multi flow split by ";"
    const commentPermission = codeValueArr?.includes(currentWorkFlow);

    const systemMessage = useSelector((state) => state.systemMessage.systemMessage);
    // const consolidationDetail = useSelector((state) => state.consolidationDetail);

    const isSubmitDisabled = () => {
        // for debug, return false for debug validation
        const isAllSubmitted = applicationDetail.siteInfo.every((item) => item.status === 1);
        return !isAllSubmitted;

        // return false;
    };
    const submitCondition = () => {
        if (compareEmail(applicationDetail.applicationForm.email, userDetail?.email)) {
            return true;
        }

        const isCiDelegate = applicationDetail.ciDelegation.some((item) => compareEmail(item.email, userDetail?.email));
        return isCiDelegate;
    };

    const getSortList = (validationFailList) => {
        const listOfLookup = validationFailList.map((item) => {
            return siteInfoLookup()?.[item];
        });

        const sorted = _.sortBy(listOfLookup, (obj) => {
            if (obj.sortKey) {
                return obj.sortKey;
            } else {
                let oFieldName = `${obj.number}. ${obj.label}`;
                let data = oFieldName.substring(0, 2);

                if (!data.endsWith('.')) {
                    oFieldName = ';' + oFieldName;
                }

                return oFieldName;
            }
        });

        return sorted;
    };

    const amendmentDisplayCondition = () => {
        const isStudyAmendment = applicationDetail?.applicationForm?.underAmendment;

        if (isStudyAmendment) {
            if (compareEmail(applicationDetail.historyCi, userDetail?.email)) {
                return true;
            }

            const isCiDelegate = applicationDetail.ciDelegation.some((item) =>
                compareEmail(item.email, userDetail?.email),
            );
            return isCiDelegate;
        } else {
            const currentSiteAmendment = applicationDetail.siteInfo.find((item) => {
                return item.underAmendment;
            });

            const amendSiteId = currentSiteAmendment.id;

            // check if current email is sitePI
            const isSitePI = applicationDetail.pi.some((item) => {
                return (
                    amendSiteId === item.siteInfo.id && item.email?.toLowerCase() === userDetail.email?.toLowerCase()
                );
            });

            if (isSitePI) {
                return true;
            }

            const isSiteDelegate = applicationDetail.piDelegation.some((item) => {
                return (
                    amendSiteId === item.siteInfo.id && item.email?.toLowerCase() === userDetail.email?.toLowerCase()
                );
            });

            if (isSiteDelegate) {
                return true;
            }

            return false;
        }
    };

    const handleSaveApplicationDetail = (requestData, title = GENERAL_SUBMIT_SUCCESS) => {
        setGlobalLoading(true);

        dispatch({
            type: SUBMIT_APPLICATION_FORM,
            payload: {
                applicationFormId: formId,
                requestData,
                callback: () => {
                    showDialog({
                        description: title,
                        disableCancelButton: true,
                    });
                    history.push(`/`);
                },
                final: () => {
                    setGlobalLoading(false);
                },
            },
        });
    };

    const applicationSave = async (disableSaveConfirm = false, callback = () => null) => {
        const state = getStore().getState();

        // check text max length overflow problem
        const textLength = state.textLength;

        const hasTextLengthOverflow = Object.entries(textLength).some(([key, value]) => {
            return value;
        });

        if (hasTextLengthOverflow) {
            let textLengthMessage = TEXT_OVERFLOW;

            const firstKey = Object.entries(textLength).filter(([key, value]) => {
                return value;
            })?.[0]?.[0];

            const questionNumber = { ...studyInfoLookup(), ...siteInfoLookup() }?.[firstKey]?.number;

            if (questionNumber) {
                textLengthMessage += `, please refer to question number ${questionNumber}`;
            }

            return showDialog({
                description: textLengthMessage,
                disableCancelButton: true,
            });
        }

        const { isPass, message } = formCheckBeforeSave();

        if (!isPass) {
            return await showDialog({
                description: message,
                disableCancelButton: true,
            });
        }

        dispatch({
            type: UPDATE_APPLICATION_FORM_DETAIL_VALID_STATE,
            payload: {
                clickedSave: true,
            },
        });

        if (!disableSaveConfirm) {
            const isConfirm = await showDialog({
                description: SAVE_APPLICATION_DATA,
            });

            if (!isConfirm) {
                return;
            }
        }

        setGlobalLoading(true);

        dispatch({
            type: SAVE_REMOTE_APPLICATION_DETAIL,
            payload: {
                id: applicationId,
                tabType,
                callback: async () => {
                    if (!disableSaveConfirm) {
                        setTimeout(() => {
                            showDialog({
                                description: UPDATE_APPLICATION_DETAIL_SUCCESS,
                                disableCancelButton: true,
                            });
                        }, 50);
                    }

                    callback();
                },
                final: () => {
                    setGlobalLoading(false);
                },
            },
        });
    };

    useSubscribe('saveApplication', applicationSave);

    const onOpenCommentSummary = () => {

        // TODO: conditional show comment summary

        dispatch({
            type: SET_COMMENT,
            payload: {
                isShowCommentSummary: true,
            },
        });
    }

    const consolidationStatus = [FOR_REVIEW, TERMINATED, COMPLETED, REVIEWED, ACKNOWLEDGED, DISAPPROVED, APPROVED];

    let actions = [
        {
            text: 'Save',
            tag: 'consolidation-save',
            status: consolidationStatus,
            condition: () => {
                return permissionChecking({
                    applicationDetail,
                    tabType,
                });
            },
            action: async () => {
                dispatch({
                    type: SAVE_CONSOLIDATION_DETAIL,
                    payload: {
                        formId,
                        documentType,
                        callback: () => {
                            showDialog({
                                description: CONSOLIDATION_SAVED,
                                disableCancelButton: true,
                            });
                        },
                    },
                });
            },
            showInRoles: [IRB, SECRETARY],
            showInTab: TAB_CONSOLIDATION,
        },
        {
            text: 'Confirm', // confirm button for confirming consolidation
            tag: 'consolidation-confirm',
            status: consolidationStatus,
            condition: () => {
                return permissionChecking({
                    applicationDetail,
                    tabType,
                });
            },
            action: async () => {
                dispatch({
                    type: SUBMIT_CONSOLIDATION_DETAIL,
                    payload: {
                        isPostApproval: isAmendment,
                        formId,
                        documentType,
                        showDialog,
                        callback: () => {
                            showDialog({
                                description: GENERAL_CONSOLIDATION_SUCCESS,
                                disableCancelButton: true,
                            });
                            history.push('/');
                        },
                    },
                });
            },
            showInRoles: [IRB, SECRETARY],
            showInTab: TAB_CONSOLIDATION,
        },
        {
            text: 'Download Approval Letter',
            tag: 'download-approval-letter',
            status: consolidationStatus,
            action: async () => {
                dispatch({
                    type: DOWNLOAD_APPROVAL_LETTER,
                    payload: {
                        formId,
                        showDialog,
                        documentType,
                        msg: !isAmendment ? systemMessage.warnChoseDecisionAndRefNo : systemMessage.warnChoseDecision,
                    },
                });
            },
            condition: () => {
                return permissionChecking({
                    applicationDetail,
                    tabType,
                });
            },
            showInRoles: [IRB, SECRETARY],
            showInTab: TAB_CONSOLIDATION,
        },
        {
            text: 'Save',
            icon: <Save />,
            status: [DRAFT, RETURNED, SUBMITTED, RE_SUBMITTED, DISTRIBUTED],
            tag: 'app-save',
            action: () => applicationSave(false),
            showInRoles: [APPLICANT, CCO, CLUSTER_ADMIN],
            type: 'save',
        },
        {
            text: 'Print',
            tag: 'print',
            status: statusLookup.map((item) => item.key),
            action: async () => {
                // setGlobalLoading(true);

                const { isPass } = formCheckBeforeSave();

                if (!isPass) {
                    return await showDialog({
                        description:
                            'Please complete table 11.2.3 Study article licence registration before printing the form',
                        disableCancelButton: true,
                    });
                }

                const isFormUpdate = await isFormChanged();

                // should save the form before printing
                if (isFormUpdate) {
                    const isConfirm = await showDialog({
                        description: SAVE_BEFORE_PRINT,
                    });

                    if (!isConfirm) {
                        return;
                    } else {
                        setGlobalLoading(true);
                        dispatch({
                            type: SAVE_REMOTE_APPLICATION_DETAIL,
                            payload: {
                                id: applicationId,
                                tabType,
                                callback: async () => {
                                    dispatch({
                                        type: GET_DOWNLOAD_GENERATE_DOC,
                                        payload: {
                                            id: formId,
                                            type: 'applicationform',
                                            callback: () => {
                                                setGlobalLoading(false);
                                            },
                                        },
                                    });
                                },
                            },
                        });
                    }
                } else {
                    // if no changes detected,
                    setGlobalLoading(true);
                    dispatch({
                        type: GET_DOWNLOAD_GENERATE_DOC,
                        payload: {
                            id: formId,
                            type: 'applicationform',
                            callback: () => {
                                setGlobalLoading(false);
                            },
                        },
                    });
                }
            },
            showInRoles: [APPLICANT, CCO, IRB, SECRETARY, CLUSTER_ADMIN, HO_ADMIN, REVIEWER],
            showInTab: [TAB_STUDY, TAB_SITE, TAB_AMENDMENT],
        },
        {
            text: 'Submit',
            icon: '',
            status: DRAFT,
            tag: 'app-submit',
            isDisabled: isSubmitDisabled,
            condition: submitCondition,
            action: async () => {
                // check text max length overflow problem
                const state = getStore().getState();
                const textLength = state.textLength;

                const hasTextLengthOverflow = Object.entries(textLength).some(([key, value]) => {
                    return value;
                });

                if (hasTextLengthOverflow) {
                    let textLengthMessage = TEXT_OVERFLOW;

                    const firstKey = Object.entries(textLength).filter(([key, value]) => {
                        return value;
                    })?.[0]?.[0];

                    const questionNumber = { ...studyInfoLookup(), ...siteInfoLookup() }?.[firstKey]?.number;

                    if (questionNumber) {
                        textLengthMessage += `, please refer to question number ${questionNumber}`;
                    }

                    return showDialog({
                        description: textLengthMessage,
                        disableCancelButton: true,
                    });
                }

                const formValidMsg = checkFormValid(applicationDetail, false, false);

                if (!formValidMsg.isFormValid) {
                    await showDialog({
                        description: FORM_SUBMIT_TIPS,
                        messages: formValidMsg.messages,
                        disableCancelButton: true,
                    });
                } else {
                    const isConfirm = await showDialog({
                        description: COMPLETE_BEFORE_SUBMIT,
                    });

                    if (isConfirm) {
                        const requestData = {
                            action: 'submit',
                        };
                        handleSaveApplicationDetail(requestData);
                    }
                }

                dispatch({
                    type: UPDATE_APPLICATION_FORM_DETAIL_VALID_STATE,
                    payload: {
                        clickedSubmit: true,
                    },
                });
            },
            showInRoles: [APPLICANT],
        },
        {
            text: 'Confirm request for return',
            icon: '',
            tag: 'confirm-request-for-return',
            status: REQUEST_FOR_RETURN,
            action: async () => {
                const { submit, comment, expiryDate } = await showCommentDialog({
                    title: CONFIRM_REQUEST_TO_RETURN_CONFIRM,
                    placeholder: 'Leave your comments',
                    isRequired: true,
                    showExpiryDate: true,
                });

                if (!submit) {
                    return;
                }

                setGlobalLoading(true);

                dispatch({
                    type: UPDATE_APPLICATION_STATUS_WITH_DETAIL,
                    payload: {
                        id: applicationId,
                        status: RETURNED,
                        currentStatus: statusId,
                        expiryDate,
                        details: [
                            {
                                comment,
                                type: statusDetailType.STUDY_INFO,
                                value: applicationId,
                            },
                        ],
                        updateApplicationDetail: true,
                        callback: () => {
                            showDialog({
                                description: CONFIRM_REQUEST_FOR_RETURN_SUCCESS,
                                disableCancelButton: true,
                            });
                        },
                        final: () => {
                            setGlobalLoading(false);
                        },
                    },
                });
            },
            showInRoles: [CCO, SECRETARY],
        },
        {
            text: 'Distribute',
            tag: 'distribute',
            status: [SUBMITTED, RE_SUBMITTED],
            condition: () => {
                if (statusId === SUBMITTED) {
                    return true;
                }

                return false;
            },
            action: async () => {
                const { submit, comment, fileIds, cluster } = await showCommentDialog({
                    title: GENERAL_DISTRIBUTE_TIPS,
                    placeholder: 'Leave your comments (if any)',
                    showUploadButton: true,
                    isRequired: false,
                    showClusterSelect: true,
                });
                if (!submit) {
                    return;
                }

                setGlobalLoading(true);

                dispatch({
                    type: UPDATE_APPLICATION_STATUS_WITH_DETAIL,
                    payload: {
                        id: formId,
                        status: DISTRIBUTED,
                        currentStatus: statusId,
                        hasCCOAction: true,
                        cluster,
                        details: [
                            {
                                comment,
                                uploadTempId: fileIds,
                            },
                        ],
                        // updateApplicationDetail: true,
                        callback: () => {
                            showDialog({
                                description: APPLICATION_DISTRIBUTE_SUCCESS,
                                disableCancelButton: true,
                            });
                            history.push('/');
                        },
                        // onError: async (error) => {
                        //     showDialog({
                        //         description: error.message,
                        //         disableCancelButton: true,
                        //         isError: true,
                        //     });
                        // },
                        final: () => {
                            setGlobalLoading(false);
                        },
                    },
                });
            },
            showInRoles: [CCO],
            type: 'save',
        },
        {
            text: 'Verify',
            tag: 'verify',
            status: [DISTRIBUTED],
            action: async () => {
                const { submit, comment, fileIds } = await showCommentDialog({
                    title: GENERAL_VERIFY_TIPS,
                    placeholder: 'Leave your comments (if any)',
                    isRequired: false,
                    showUploadButton: true,
                });

                if (!submit) {
                    return;
                }

                setGlobalLoading(true);
                dispatch({
                    type: UPDATE_APPLICATION_STATUS_WITH_DETAIL,
                    payload: {
                        id: formId,
                        status: VERIFIED,
                        currentStatus: statusId,
                        details: [
                            {
                                comment,
                                uploadTempId: fileIds,
                            },
                        ],
                        // updateApplicationDetail: true,
                        callback: () => {
                            history.push('/');
                            showDialog({
                                description: APPLICATION_VERIFY_SUCCESS,
                                disableCancelButton: true,
                            });
                        },
                        final: () => {
                            setGlobalLoading(false);
                        },
                    },
                });
            },
            showInRoles: [CLUSTER_ADMIN],
        },
        {
            text: 'Reject request for return',
            tag: 'reject-request-for-return',
            status: [REQUEST_FOR_RETURN],
            action: async () => {
                const { submit, comment, fileIds } = await showCommentDialog({
                    title: REJECT_RETURN_OF_REQUEST_TIPS,
                    placeholder: 'Leave your comments',
                    isRequired: true,
                    showUploadButton: true,
                });

                if (!submit) {
                    return;
                }

                setGlobalLoading(true);

                dispatch({
                    type: UPDATE_APPLICATION_STATUS_WITH_DETAIL,
                    payload: {
                        id: formId,
                        status: REJECT_REQUEST_FOR_RETURN,
                        currentStatus: statusId,
                        details: [
                            {
                                comment,
                                uploadTempId: fileIds,
                            },
                        ],
                        // updateApplicationDetail: true,
                        callback: async () => {
                            await showDialog({
                                description: REJECT_SUCCESS,
                                disableCancelButton: true,
                            });
                            history.push('/');
                        },
                        final: () => {
                            setGlobalLoading(false);
                        },
                    },
                });
            },
            showInRoles: [CCO, SECRETARY],
            type: 'save',
        },
        {
            text: 'Confirm',
            tag: 'confirm',
            status: [SUBMITTED, VERIFIED, RE_SUBMITTED, DISTRIBUTED],
            customDialog: (
                <ConfirmModal
                    applicationDetail={applicationDetail}
                    isShow={isConfirmDialogShow}
                    onSubmit={async ({ irbFlow, comment, files, irbNo }) => {
                        try {
                            const response = await api.comment.commentStatusCheck({
                                params: {
                                    type: "2",
                                },
                                formId: formId
                            });
                            if (response?.status !== 200) return;
                            if (!response?.data?.result) {
                                dispatch(
                                    setGlobal({
                                        isErrorShow: true,
                                        errorMessage: 'All comments must be resolved',
                                        isGlobalLoadingShow: false,
                                        errorTitle: 'Error',
                                    }),
                                );
                                return;
                            }
                        } catch (error) {
                            console.warn(error);
                        }
                        setConfirmDialogShow(false);

                        // update the application status
                        setGlobalLoading(true);

                        const postData = {
                            details: [
                                {
                                    comment,
                                    uploadTempId: files.map((item) => {
                                        return item.key;
                                    }),
                                },
                            ],
                            irbNo,
                        };

                        if (!checkNull(irbFlow)) {
                            postData.irbFlow = irbFlow;
                        }

                        dispatch({
                            type: UPDATE_APPLICATION_STATUS_WITH_DETAIL,
                            payload: {
                                id: formId,
                                status: CONFIRMED,
                                currentStatus: statusId,
                                hasCCOAction: true,
                                ...postData,
                                // updateApplicationDetail: true,
                                callback: async () => {
                                    if ([SECRETARY, IRB].includes(userRole)) {
                                        const result = await showDialog({
                                            description: ARRANGE_REVIEW_ARRANGEMENT_CONFIRM,
                                        });
                                        if (result) {
                                            history.push('/review/arrange-meeting');
                                        } else {
                                            history.push('/');
                                        }
                                    } else {
                                        history.push('/');
                                        await showDialog({
                                            description: CONFIRM_APPLICATION_SUCCESS,
                                            disableCancelButton: true,
                                        });
                                    }
                                },
                                final: () => {
                                    setGlobalLoading(false);
                                },
                            },
                        });
                    }}
                    onCancel={() => {
                        setConfirmDialogShow(false);
                    }}
                />
            ),
            action: async () => {
                setConfirmDialogShow(true);
            },
            condition: () => {
                let isValid = true;

                if (statusId === CONFIRMED) {
                    isValid = false;
                }

                if (statusId === DISTRIBUTED && userRole === 'cco') {
                    isValid = false;
                }

                return isValid;
            },
            showInRoles: [CCO, SECRETARY],
            type: 'save',
        },
        {
            text: 'Return',
            tag: 'return',
            status: [SUBMITTED, RE_SUBMITTED, FOR_REVIEW, REVIEWED, VERIFIED, DISTRIBUTED, RETURN_FROM_IRB, CONFIRMED],
            condition: () => returnCondition(userRole, statusId), //returnCondition,
            customDialog: (
                <ReturnCommentDialog
                    title={GENERAL_RETURN_TIPS}
                    isShow={isCCOReturnDialog}
                    currentState={statusId}
                    onCancel={() => setCCOReturnDialog(false)}
                    formId={applicationId}
                    applicationDetail={applicationDetail}
                    commentPermission={commentPermission}
                />
            ),
            action: async () => {
                if (statusId === VERIFIED) {
                    const { submit, comment, fileIds } = await showCommentDialog({
                        title: CONFIRM_RETURN_TO_CLUSTER_ADMIN,
                        placeholder: 'Leave your comments (if any)',
                        isRequired: false,
                        showUploadButton: true,
                    });

                    if (!submit) {
                        return;
                    }

                    setGlobalLoading(true);

                    dispatch({
                        type: UPDATE_APPLICATION_STATUS_WITH_DETAIL,
                        payload: {
                            id: formId,
                            status: DISTRIBUTED,
                            currentStatus: statusId,
                            hasCCOAction: true,
                            details: [
                                {
                                    comment,
                                    uploadTempId: fileIds,
                                },
                            ],
                            // updateApplicationDetail: true,
                            // onError: async (error) => {
                            //     showDialog({
                            //         description: error.message,
                            //         disableCancelButton: true,
                            //         isError: true,
                            //     });
                            // },
                            callback: async () => {
                                history.push('/');
                                await showDialog({
                                    description: GENERAL_RETURN_TO_CLUSTER_ADMIN,
                                    disableCancelButton: true,
                                });
                            },
                            final: () => {
                                setGlobalLoading(false);
                            },
                        },
                    });
                } else {
                    setCCOReturnDialog(true);
                }
            },
            showInRoles: [CCO, SECRETARY, CLUSTER_ADMIN],
            showInTab: [TAB_STUDY, TAB_SITE, TAB_AMENDMENT],
        },
        {
            text: 'Return', // this is the case of "RETURN_FROM_IRB"
            status: [FOR_REVIEW, REVIEWED, CONFIRMED],
            tag: 'return-from-irb',
            action: async () => {
                const { submit, comment, expiryDate, fileIds } = await showCommentDialog({
                    title: GENERAL_RETURN_TIPS,
                    placeholder: 'Leave your comments (if any)',
                    isRequired: false,
                    showExpiryDate: true,
                    defaultExpiryDate: '',
                    showUploadButton: true,
                });

                if (!submit) {
                    return;
                }

                setGlobalLoading(true);

                dispatch({
                    type: UPDATE_APPLICATION_STATUS_WITH_DETAIL,
                    payload: {
                        id: formId,
                        status: RETURN_FROM_IRB,
                        currentStatus: statusId,
                        expiryDate: new Date(expiryDate),
                        details: [
                            {
                                comment,
                                uploadTempId: fileIds,
                            },
                        ],
                        // updateApplicationDetail: true,
                        callback: () => {
                            history.push('/');
                            showDialog({
                                description: GENERAL_RETURN_SUCCESS,
                                disableCancelButton: true,
                            });
                        },
                        // onError: async (error) => {
                        //     showDialog({
                        //         description: error.message,
                        //         disableCancelButton: true,
                        //         isError: true,
                        //     });
                        // },
                        final: () => {
                            setGlobalLoading(false);
                        },
                    },
                });
            },
            showInRoles: [IRB],
        },
        {
            text: 'Re-submit',
            status: RETURNED,
            tag: 'app-re-submit',
            isDisabled: isSubmitDisabled,
            condition: submitCondition,
            action: async () => {
                const formValidMsg = checkFormValid(applicationDetail);

                if (!formValidMsg.isFormValid) {
                    await showDialog({
                        title: FORM_SUBMIT_TIPS,
                        messages: formValidMsg.messages,
                        disableCancelButton: true,
                    });
                } else {
                    try {
                        const response = await api.comment.commentStatusCheck({
                            params: {
                                type: "1",
                            },
                            formId: formId
                        });
                        if (response?.status !== 200) return;
                        if (!response?.data?.result) {
                            dispatch(
                                setGlobal({
                                    isErrorShow: true,
                                    errorMessage: 'All comments must be responded before submission.\nFor details, please refer to the “Comment Summary”.',
                                    isGlobalLoadingShow: false,
                                    errorTitle: 'Error',
                                }),
                            );
                            return;
                        }
                    } catch (error) {
                        console.warn(error);
                    }

                    const { submit, comment } = await showCommentDialog({
                        title: GENERAL_RE_SUBMIT_TIPS,
                        placeholder: 'Leave your message (if any)',
                        isRequired: false,
                    });

                    if (!submit) {
                        return;
                    }

                    const requestData = {
                        action: 'resubmit',
                        formStatus: RE_SUBMITTED,
                        comment: comment,
                    };

                    handleSaveApplicationDetail(requestData, GENERAL_RE_SUBMIT_SUCCESS);
                }

                dispatch({
                    type: UPDATE_APPLICATION_FORM_DETAIL_VALID_STATE,
                    payload: {
                        clickedSubmit: true,
                    },
                });
            },
            showInRoles: [APPLICANT],
            type: 'save',
        },
        {
            text: statusId === DRAFT ? 'Discard' : 'Withdraw',
            tag: 'withdraw',
            status: [RETURNED, DRAFT, EXPIRED],
            condition: isAmendment ? amendmentDisplayCondition : submitCondition,
            action: async () => {
                let isSubmit = false;
                let comment = '';

                if (statusId === DRAFT) {
                    isSubmit = await showDialog({
                        description: APPLICATION_DISCARD_TIPS,
                    });
                } else {
                    const { submit, comment: commentRes } = await showCommentDialog({
                        title: APPLICATION_WITHDRAW_TIPS,
                        placeholder: 'Please state the reason(s).',
                    });

                    isSubmit = submit;
                    comment = commentRes;
                }

                if (!isSubmit) {
                    return;
                }

                setGlobalLoading(true);

                const postData = {
                    id: formId,
                    status: WITHDRAWN,
                    currentStatus: statusId,
                    // updateApplicationDetail: true,
                    callback: () => {
                        showDialog({
                            description:
                                statusId === DRAFT ? APPLICATION_DISCARD_SUCCESS : APPLICATION_WITHDRAW_SUCCESS,
                            disableCancelButton: true,
                        });

                        history.push('/');
                    },
                    final: () => {
                        setGlobalLoading(false);
                    },
                };

                if (statusId !== DRAFT) {
                    postData.details = [
                        {
                            comment,
                        },
                    ];
                }

                dispatch({
                    type: UPDATE_APPLICATION_STATUS_WITH_DETAIL,
                    payload: postData,
                });
            },
            showInRoles: [APPLICANT],
            // showInRoles: [],
            type: 'save',
        },
        {
            text: 'For Review',
            tag: 'for-review',
            status: [],
            action: async () => {
                const isConfirm = await showDialog({
                    description: GENERAL_FOR_REVIEW,
                });

                if (!isConfirm) {
                    return;
                }
            },
            showInRoles: [],
            type: 'save',
        },
        {
            text: 'Return to Site',
            tag: 'return-to-site',
            status: [DRAFT, RETURNED],
            condition: (extra) => {
                if (isAmendment) {
                    const isCI = checkCIAmendment(applicationDetail, userDetail);

                    if (isCI) {
                        const currentSite = applicationDetail.siteInfo.find((item) => item.id === siteInfoId);
                        const isStudyAmend = applicationDetail.applicationForm.underAmendment;
                        const isSiteUnderAmendment = currentSite?.underAmendment;

                        // if isStudyAmend === true, the amendment form is base on study-info, if isSiteUnderAmendment === true && isStudyAmend === true, that means the current site is newly added

                        // 1 === submitted status
                        if (currentSite?.status === 1 && isSiteUnderAmendment && isStudyAmend) {
                            return true;
                        }
                    }

                    return false;
                } else {
                    const isCI = compareEmail(applicationDetail.applicationForm?.email, userDetail?.email);
                    const isCIDelegation = applicationDetail.ciDelegation.some((item) =>
                        compareEmail(item.email, userDetail?.email),
                    );

                    if (isCI || isCIDelegation) {
                        const currentSite = applicationDetail.siteInfo.find((item) => item.id === siteInfoId);

                        // 1 === submitted status
                        if (currentSite?.status === 1) {
                            return true;
                        }
                    }

                    return false;
                }
            },
            action: async (extra) => {
                const currentSite = applicationDetail.siteInfo.find((item) => item.id === siteInfoId);

                const isConfirm = await showDialog({
                    description: SITE_RETURNED_TIPS,
                });

                if (isConfirm) {
                    setGlobalLoading(true);

                    dispatch({
                        type: RETURN_TO_SITE,
                        payload: {
                            applicationFormId: applicationId,
                            siteInfoId: currentSite.id,
                            callback: () => {
                                showDialog({
                                    description: APPLICATION_RETURN_TO_SITE_SUCCESS,
                                    disableCancelButton: true,
                                });
                            },
                            onError: () => {
                                // showDialog({
                                //     title: UPDATE_APPLICATION_FORM_FAIL,
                                //     disableCancelButton: true,
                                //     isError: true,
                                // });
                            },
                            final: () => {
                                setGlobalLoading(false);
                            },
                        },
                    });
                }
            },
            showInRoles: [APPLICANT],
        },
        {
            text: 'Submit Site Info',
            tag: 'send-to-ci',
            status: [DRAFT, RETURNED],
            condition: (extra) => {
                const hasPermission = permissionChecking({
                    applicationDetail,
                    siteInfoId,
                    tabType,
                    isAmendmentCreate: false,
                    isAmendmentEdit: false,
                });

                if (!hasPermission) {
                    return false;
                }

                // site-info status: 0 === saved, 1 === submitted, 2 === returned
                const currentSiteInfo = applicationDetail.siteInfo.find((item) => {
                    return item.id === siteInfoId;
                });

                if (currentSiteInfo) {
                    if (currentSiteInfo.status !== 1) {
                        return true;
                    }
                }

                return false;
            },
            action: async (extra) => {
                const state = getStore().getState();
                const validationObject = state.applicationDetailValid;
                const detailValidation = state.validation.site;
                const { siteInfoValid } = validationObject;
                const currentSiteValidation = siteInfoValid[siteInfoId];
                // check if text length problem
                const textLength = state.textLength;

                const hasTextLengthOverflow = Object.entries(textLength).some(([key, value]) => {
                    return value;
                });

                if (hasTextLengthOverflow) {
                    let textLengthMessage = TEXT_OVERFLOW;

                    const firstKey = Object.entries(textLength).filter(([key, value]) => {
                        return value;
                    })?.[0]?.[0];

                    const questionNumber = siteInfoLookup()?.[firstKey]?.number;

                    if (questionNumber) {
                        textLengthMessage += `, please refer to question number ${questionNumber}`;
                    }

                    return showDialog({
                        description: textLengthMessage,
                        disableCancelButton: true,
                    });
                }

                const messages = [];

                let count = 0;

                Object.entries(currentSiteValidation).forEach(([key, isValid], siteErrorIndex) => {
                    // if (key !== 'declarationAndEndorsementValid') {
                    if (!isValid) {
                        if (messages.length === 0) {
                            const siteName =
                                applicationDetail.siteInfo.find((item) => item.id.toString() === siteInfoId.toString())
                                    ?.institution ?? 'undefined';
                            messages.push(
                                <div
                                    key={`header-site-${siteInfoId}-${siteErrorIndex}`}
                                    style={{
                                        fontWeight: 'bold',
                                        fontSize: 16,
                                        paddingBottom: 5,
                                        borderBottom: '1px solid #dcdcdc',
                                    }}
                                >
                                    Site ({siteName})
                                </div>,
                            );
                        }
                        let obj = detailValidation[key] ?? {};
                        obj = obj[siteInfoId] ?? {};
                        const validationFailList = Object.entries(obj)
                            .filter(([key, value]) => !value)
                            .map((item) => {
                                return item[0];
                            });

                        messages.push(
                            <div key={`site-info-${siteInfoId}-${siteErrorIndex}`}>
                                <div
                                    style={{
                                        marginTop: 10,
                                        display: 'flex',
                                        fontWeight: 'bold',
                                    }}
                                >
                                    <div style={{ width: 25 }}>{++count}.</div> {formLookup(key)}
                                </div>
                                <div style={{ paddingLeft: 25, marginTop: 5 }}>
                                    {getSortList(validationFailList)
                                        .map((item) => {
                                            return item.number ?? 'undefined';
                                        })
                                        .join(', ')}
                                </div>
                            </div>,
                        );
                    }
                });

                // skip this code for debugging
                if (messages.length > 0) {
                    return showDialog({
                        title: COMPLETE_BEFORE_NOTIFY,
                        messages,
                        disableCancelButton: true,
                    });
                }

                const isConfirm = await showDialog({
                    description: CONFIRM_TO_SEND_TO_CI,
                });

                if (!isConfirm) {
                    return;
                }

                const currentSiteInfo = applicationDetail.siteInfo.find((item) => {
                    return item.id === siteInfoId;
                });

                if (
                    applicationDetail?.applicationForm?.enableInvolvesSpecialCases &&
                    currentSiteInfo?.involvesSpecialCases === null &&
                    statusId === DRAFT &&
                    !isAmendment
                ) {
                    const isOptionConfirm = await showOptionCommentDialog();
                    if (isOptionConfirm?.result) {
                        setGlobalLoading(true);
                        dispatch({
                            type: SEND_TO_COORDINATING_INVESTIGATOR,
                            payload: {
                                applicationFormId: formId,
                                involvesSpecialCases: isOptionConfirm?.involveFlag,
                                siteInfoId,
                                tabType,
                                callback: async () => {
                                    showDialog({
                                        description: NOTIFY_CI_SUCCESS,
                                        disableCancelButton: true,
                                    });
                                },
                                final: () => {
                                    setGlobalLoading(false);
                                },
                            },
                        });
                        return;
                    }
                } else {
                    setGlobalLoading(true);
                    dispatch({
                        type: SEND_TO_COORDINATING_INVESTIGATOR,
                        payload: {
                            applicationFormId: formId,
                            siteInfoId,
                            tabType,
                            callback: async () => {
                                showDialog({
                                    description: NOTIFY_CI_SUCCESS,
                                    disableCancelButton: true,
                                });
                            },
                            final: () => {
                                setGlobalLoading(false);
                            },
                        },
                    });
                }
            },
            showInRoles: [APPLICANT],
        },
        {
            text: 'Terminate',
            tag: 'terminate',
            status: APPROVED,
            condition: () => {
                return !isAmendment;
            },
            action: async () => {
                const { submit, comment, fileIds } = await showCommentDialog({
                    title: GENERAL_TERMINATE_TIPS,
                    placeholder: 'Please state the reason(s).',
                    showUploadButton: true,
                });

                if (!submit) {
                    return;
                }

                setGlobalLoading(true);

                dispatch({
                    type: UPDATE_APPLICATION_STATUS_WITH_DETAIL,
                    payload: {
                        id: formId,
                        status: TERMINATED,
                        currentStatus: statusId,
                        details: [
                            {
                                comment,
                                uploadTempId: fileIds,
                            },
                        ],
                        // updateApplicationDetail: true,
                        callback: () => {
                            showDialog({
                                description: GENERAL_TERMINATE_SUCCESS,
                                disableCancelButton: true,
                            });
                            history.push('/');
                        },

                        final: () => {
                            setGlobalLoading(false);
                        },
                    },
                });
            },
            showInRoles: [SECRETARY, IRB],
            type: 'save',
        },
        {
            text: 'Confirm Review Result',
            tag: 'reviewer-confirm-review-result',
            status: [FOR_REVIEW],
            action: async () => {
                const rote = isAmendment ? '/post-approval-document' : '/applications';
                history.push(`${rote}/confirm-review-result?appId=${formId}&documentType=${documentType}`);
            },
            showInRoles: [REVIEWER],
            showInTab: [TAB_STUDY, TAB_SITE, TAB_AMENDMENT],
        },
        {
            text: 'View Comment Summary',
            tag: 'view-comment-summary',
            status: statusLookup.map((item) => item.key),
            action: () => {
                onOpenCommentSummary();
            },
            condition: () => {
                let check = true;
                const appStatus = applicationDetail.status?.statusId;
                if (appStatus === DRAFT) check = false;
                if (!commentPermission) check = false;
                return check;
            },
            showInRoles: [APPLICANT, CCO, IRB, SECRETARY, CLUSTER_ADMIN, HO_ADMIN, REVIEWER],
            showInTab: [TAB_STUDY, TAB_SITE],
        },
    ];

    return { filter: actions.filter((item) => (item?.showInRoles ?? []).includes(userRole)), raw: actions };
};

export default useApplicationBarAction;
